/**
 * 路由级权限控制
 *
 * - isLoggedIn: 已登录用户可访问
 * - canAccessMenu: 检查后端返回的菜单树中是否包含当前路由
 *   用于防止用户通过直接输入 URL 访问未授权的页面
 */
export default function access(
  initialState:
    | {
        currentUser?: API.CurrentUser;
        menuTree?: API.RouteItemVO[];
      }
    | undefined
) {
  const { currentUser, menuTree } = initialState ?? {};

  // 从菜单树中提取所有被授权的路径
  const authorizedPaths = new Set<string>();
  // 始终允许的基础路径
  authorizedPaths.add("/app/dashboard");
  authorizedPaths.add("/settings");
  authorizedPaths.add("/pricing");

  function collectPaths(items?: API.RouteItemVO[]) {
    if (!items) return;
    for (const item of items) {
      if (item.path) {
        authorizedPaths.add(item.path);
      }
      if (item.children) {
        collectPaths(item.children);
      }
    }
  }
  collectPaths(menuTree);

  return {
    isLoggedIn: !!currentUser,
    canAccessMenu: (route: { path?: string }) => {
      if (!currentUser) return false;
      if (!route.path) return true;
      // 精确匹配
      if (authorizedPaths.has(route.path)) return true;
      // 子路由匹配：/product/:id、/product/create 等继承 /product 的权限
      for (const p of authorizedPaths) {
        if (route.path.startsWith(p + "/")) return true;
      }
      return false;
    },
  };
}
